import { render, staticRenderFns } from "./slot.vue?vue&type=template&id=229b58c2&scoped=true&"
import script from "./slot.vue?vue&type=script&lang=js&"
export * from "./slot.vue?vue&type=script&lang=js&"
import style0 from "./slot.vue?vue&type=style&index=0&id=229b58c2&scoped=true&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229b58c2",
  null
  
)

export default component.exports